module.exports = __webpack_public_path__ + "assets/images/schedule.2efc43b86435375c2d9ed72e8fc9577b.png";